import { useLayoutEffect, useRef, useState, type ReactNode } from 'react'
import { useBackHandler } from '@/hooks/useBackHandler'
import { ActionSheetDrawer } from './ActionSheetDrawer'
import type { ActionSheetAction, ActionSheetSize } from './action-sheet-store'

type ActionSheetProps = {
  open: boolean
  onOpenChange: (open: boolean) => void
  title?: string
  description?: string
  size?: ActionSheetSize
  dismissible?: boolean
  showHandle?: boolean
  container?: HTMLElement | null
  actions?: ActionSheetAction[]
  children?: ReactNode
}

export function ActionSheet({ open, onOpenChange, title, description, size = 'auto', dismissible = true, showHandle = true, container, actions, children }: ActionSheetProps) {
  const host = useRef<HTMLSpanElement>(null)
  const closeRef = useRef<HTMLButtonElement>(null)
  const [appContainer, setAppContainer] = useState<HTMLElement | null | undefined>(undefined)
  useLayoutEffect(() => {
    const frame = host.current?.closest<HTMLElement>('.app-container')
    setAppContainer(frame ?? null)
  }, [])
  const close = () => { closeRef.current?.click() }
  useBackHandler(open, () => { if (dismissible) close() })

  return <>
    <span ref={host} hidden aria-hidden="true" />
    <ActionSheetDrawer open={open && (container !== undefined || appContainer !== undefined)} options={{ id: 0, title, description, content: children, actions, size, dismissible, showHandle }}
      container={(container === undefined ? appContainer : container) ?? null} closeRef={closeRef}
      onOpenChange={onOpenChange} onAnimationEnd={() => {}} onActionClose={close} />
  </>
}
